import React, { FC, useCallback, useState, useEffect, useContext } from 'react'
import { observer } from 'mobx-react'
import { Price, ProductImage, Stepper, Tags } from 'components'
import { classNames } from '@dt/fe-utils'
import MSDK from 'sdk/monitor'
import { cartMobx, restaurantConfig } from 'restaurant'
import Config from 'common/config/config'
// import MonthSaleInfo from '../MonthSaleInfo'
import productStyleController from '@ctrls/productStyleController'
// import { prodRecommendContent } from '../../../index'
import './index.scss'
import { advertMobx } from '@mobxStore'
import { getHistoryNew } from '@utils'
import mktController from '@ctrls/mktController'

// interface
type TProductItem = 'waterfall' | 'default';
interface IProps {
  type?: TProductItem;
  style?: any;
  wrapWidth?: number;
  onClick?: () => void;
  data: any;
  id?: string;
}

/**
 * 信息流广告
 */
const WaterfallAdvertItem: FC<IProps> = (props) => {
  const { type = 'default', data, style, id = '', wrapWidth, onClick } = props
  const history = getHistoryNew()
  const hasPic = data.pic
  const advertType = 'waterfall'
  /** 获得图片的宽高 */
  const [productStyle] = useState(() => {
    if (type === 'waterfall') {
      const imgWidth = (wrapWidth || window.innerWidth) / 2 - productStyleController.getWidthPer(3)
      const imgHeight = imgWidth * Number(data.picHeight || 360) / Number(data.picWidth || 360)
      return {
        width: imgWidth,
        height: imgHeight
      }
    } else if (type === 'default') {
      const imgWidth = (wrapWidth || window.innerWidth) - productStyleController.getWidthPer(4)
      const imgHeight = imgWidth * Number(data.picHeight || 360) / Number(data.picWidth || 360)
      return {
        width: imgWidth,
        height: imgHeight
      }
    }
  })

  /**
   * 数据采集
   */
  // 点击和曝光上报
  const handleTrace = (eventType, ad, index) => {
    MSDK.trackClicks({ eventType, ad, adType: advertType, page: index })
  }

  useEffect(() => {
    if (!hasPic) return
    let observerNode
    const target = document.getElementById(`waterfallproduct${id}`)
    try {
      observerNode = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // console.log('观察的元素进入了可视范围 ====> waterfall')
            // do something when the observed element enters the viewport
            // observer.unobserve(entry.target) // 停止观察已经进入可视范围的元素
            try {
              handleTrace('ad_show', data, data.wfQueue)
            } catch (error) {
            }
          }
        })
      })
      target && observerNode.observe(target)
    } catch (error) {
    }
    return () => {
      try {
        target && observerNode.unobserve(target)
      } catch (error) {
      }
    }
  }, [])

  // 广告位点击
  const handleClick = () => {
    const ad = data
    onClick?.()
    handleTrace('ad_click', ad, ad.wfQueue)
    advertMobx.pick(ad, advertType)
    if (['mallProduct'].includes(ad.type)) {
      history.push('/advert')
    } else if (['product'].includes(ad.type)) {
      const inMenu = ['/menu'].includes(history.location.pathname)
      const inStore = restaurantConfig.storeId
      const hasLbs = restaurantConfig?.lbs?.lat && restaurantConfig?.lbs?.lng
      const tt = 'advert'
      if (inMenu || inStore) {
        history.push('/advert')
      } else {
        history.push('/store', null, { tt })
      }
    } else if (ad.type === 'activityReserve' && ad.activity?.activityId) {
      mktController.adToActivityReserve(history, ad.activity.activityId)
    } else if (ad.type === 'activity' && ad.activity?.jumpUrl) {
      mktController.adToActive(history, ad.activity.jumpUrl)
    } else if (ad.type === 'memberCard' && ad.memberCard?.cardId) {
      mktController.adToMemberCard(history, ad.memberCard.cardId)
    } else if (ad.type === 'show' && !!ad.outLink) {
      window.location.href = ad.outLink
    } else if (ad.type === 'redeem') {
      mktController.adToRedeem(history)
    } else if (ad.type === 'groupBuy') {
      mktController.adToGroupBuy(history)
    } else if (ad.type === 'giftCard') {
      mktController.adToGiftCard(history)
    } else if (ad.type === 'weChatWork') {
      history.push(`/weChatWork/${type}`)
    }
  }

  return (
    <div
      className={classNames(
        'waterfall-advert-item product-item mini',
        type,
      )}
      style={style ? {
        visibility: style.left ? 'visible' : 'hidden',
        left: style.left,
        top: style.top
      } : null}
      id={`waterfallproduct${id}`}
      onClick={() => handleClick()}
    >
      {
        hasPic ? (
          <img
            src={data.pic || ''}
            width={productStyle.width}
            height={productStyle.height}
            className={type === 'waterfall' ? 'waterfall-img' : ''}
          />
        ) : (
          <div className='waterfall-ad-notimg'>
            {!!data.wfName && <div className='ad-name'>{data.wfName}</div>}
            {!!data.wfBtnTxt && <div className='ad-btn'>{data.wfBtnTxt}</div>}
          </div>
        )
      }
    </div>
  )
}
export default observer(WaterfallAdvertItem)
